import React, { memo, ReactElement, Children, cloneElement, MouseEventHandler } from 'react'
import { DraggableProvided } from 'react-beautiful-dnd'
import classNames from 'classnames'
import { IStickyHeaderStyleProps } from './Table'

export interface ITableRowProps extends JSX.ElementChildrenAttribute {
  id?: string
  tableCellType?: string
  selected?: boolean
  highlightOnHover?: boolean
  onClick?: MouseEventHandler
  dataTest?: string
  className?: string
  draggableProvided?: DraggableProvided
  isDraggable?: boolean
  isDragging?: boolean
  stickyHeader?: boolean
  stickyHeaderStyle?: IStickyHeaderStyleProps
}

export const TableRow = memo<ITableRowProps>(
  ({
    children,
    className,
    dataTest,
    draggableProvided,
    highlightOnHover,
    isDraggable,
    isDragging,
    onClick,
    selected,
    stickyHeader,
    stickyHeaderStyle,
    tableCellType,
  }) => {
    const rowClassName = classNames(className, {
      'row-dragging': highlightOnHover && isDragging,
      'row-selected': selected,
      'row-hoverable': highlightOnHover,
      pointer: !!onClick,
    })

    const validChildren = Array.isArray(children)
      ? (children as ReactElement[]).filter(Boolean)
      : (children as ReactElement)

    return (
      <tr
        className={rowClassName}
        onClick={onClick}
        data-test={dataTest}
        {...draggableProvided?.draggableProps}
        {...draggableProvided?.dragHandleProps}
        ref={draggableProvided?.innerRef}>
        {Children.map(validChildren, (child: ReactElement, idx: number) =>
          cloneElement(child, {
            tableCellType,
            stickyHeader,
            stickyHeaderStyle,
            isDraggable: idx === 0 && isDraggable,
          })
        )}
      </tr>
    )
  }
)
